var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading
      ? _c(
          "div",
          {
            staticClass:
              "loadData w-100 d-flex justify-content-center align-items-center"
          },
          [
            _c("b-spinner", {
              staticClass: "text-center",
              attrs: { variant: "primary" }
            })
          ],
          1
        )
      : _c(
          "div",
          [
            _c("GeneralSummary"),
            _c("HoldingEnterprises", { attrs: { loading: _vm.loading } }),
            _c("PaginationTransactionality", {
              attrs: { show: _vm.transactionalityPagination.totalPaginas > 1 },
              model: {
                value: _vm.page,
                callback: function($$v) {
                  _vm.page = $$v
                },
                expression: "page"
              }
            }),
            _c("BillingInformation", { staticClass: "mt-5" })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }